import { FC } from "react";
import { withConditionalComponent } from "src/HOC";
import OriginComponentWeb from "./layouts/OriginComponent.web";
import OriginComponentMob from "./layouts/OriginComponent.mob";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { PlaneTakeoffIcon } from "@Icons/index";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";

const OriginSelectComponent = withConditionalComponent(OriginComponentWeb, OriginComponentMob);

const OriginComponent: FC<any> = ({ errorFields }) => {
  const { t } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const name = "origin";
  const hasError = errorFields.includes(name);

  const fieldProps = {
    name,
    icon: PlaneTakeoffIcon,
    label: t("Flights.search.from"),
    hasError,
    dependencies: ["destination"],
    rules: [
      { required: true, message: i18n.t("Flights.search.originRequired") },
      ({ getFieldValue }: any) => ({
        validator(_: any, value: any) {
          const destination = getFieldValue("destination");
          if (value?.value !== destination?.value || !value?.value) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(i18n.t("Flights.search.originEqualsDestination")));
        },
      }),
    ],
    className: "flex-5 h-15! border-none! focus:outline-none! focus-within:ring-0! text-font-strong! w-full",
  };

  return <OriginSelectComponent trigger={isLargeScreen} props={fieldProps} />;
};

export default OriginComponent;
